import "./ProyectosCommon.css";
import { BaseSmallModalFormComponent } from "../../../shared/components/modal/BaseSmallModalFormComponent";
import { TecnicoResponse } from "../../../shared/response/proyectos/TecnicoResponse";
import { TecnicoPayload } from "../../../shared/services/api/payload/proyectos/TecnicoPayload";
import { TecnicoSaveService } from "../../services/proyectos/TecnicoSaveService";
import { errorMessageComponent } from "../../../shared/components/error/ErrorMessageComponent";

export class TecnicoFormModal extends BaseSmallModalFormComponent<
  TecnicoResponse,
  TecnicoPayload,
  TecnicoSaveService
> {
  private _nombre!:   HTMLInputElement;
  private _email!:    HTMLInputElement;
  private _telefono!: HTMLInputElement;
  private _zona!:     HTMLInputElement;
  private _activo!:   HTMLInputElement;

  constructor(
    private readonly _onSavedCb: (item: TecnicoResponse) => void,
    private readonly _item?: TecnicoResponse,
  ) {
    super(new TecnicoSaveService());
  }

  protected get title(): string { return this._item ? "Editar técnico" : "Nuevo técnico"; }
  protected get saveText(): string { return "Guardar"; }

  protected renderBody(): string {
    const c = this._item;
    return `
      <div class="cl-form-fields">
        <div class="cl-form-group">
          <label class="cl-form-label" for="tec-nombre">Nombre <span class="cl-required">*</span></label>
          <input id="tec-nombre" class="sx-input" type="text" maxlength="120" value="${this._esc(c?.nombre ?? "")}" placeholder="Juan Pérez">
        </div>
        <div class="cl-form-group">
          <label class="cl-form-label" for="tec-email">Correo <span class="cl-required">*</span></label>
          <input id="tec-email" class="sx-input" type="email" value="${this._esc(c?.email ?? "")}" placeholder="juan@sextante.com">
        </div>
        <div class="pr-form-row">
          <div class="cl-form-group">
            <label class="cl-form-label" for="tec-telefono">Teléfono</label>
            <input id="tec-telefono" class="sx-input" type="text" value="${this._esc(c?.telefono ?? "")}" placeholder="+57 300…">
          </div>
          <div class="cl-form-group">
            <label class="cl-form-label" for="tec-zona">Zona</label>
            <input id="tec-zona" class="sx-input" type="text" value="${this._esc(c?.zona ?? "")}" placeholder="Costa Atlántica">
          </div>
        </div>
        <label class="pr-check">
          <input id="tec-activo" type="checkbox" ${c ? (c.isActivo ? "checked" : "") : "checked"}>
          <span>Técnico activo</span>
        </label>
      </div>
    `;
  }

  protected override onAfterRender(el: HTMLDivElement): void {
    this._nombre   = el.querySelector<HTMLInputElement>("#tec-nombre")!;
    this._email    = el.querySelector<HTMLInputElement>("#tec-email")!;
    this._telefono = el.querySelector<HTMLInputElement>("#tec-telefono")!;
    this._zona     = el.querySelector<HTMLInputElement>("#tec-zona")!;
    this._activo   = el.querySelector<HTMLInputElement>("#tec-activo")!;

    this._nombre.addEventListener("input", () => this._validate());
    this._email.addEventListener("input", () => this._validate());
    this._validate();
  }

  protected buildPayload(): TecnicoPayload {
    return {
      id: this._item?.id ?? null,
      nombre: this._nombre.value.trim(),
      email: this._email.value.trim(),
      telefono: this._telefono.value.trim(),
      zona: this._zona.value.trim(),
      isActivo: this._activo.checked,
    };
  }

  /** Avisa si la ficha se enlazó a un usuario que ya existía (Nitrofert) y cierra el formulario. */
  protected override onSaved(item: TecnicoResponse): void {
    if (item.enlazadoAUsuarioExistente) {
      errorMessageComponent.addSuccess(
        "Ficha enlazada",
        "Ya había un usuario con ese correo: la ficha de técnico quedó enlazada a ese usuario.",
      );
    }
    this._onSavedCb(item);
    this.dispose();
  }

  private _validate(): void {
    const email = this._email.value.trim();
    const ok = this._nombre.value.trim().length >= 1 && email.length >= 3 && email.includes("@");
    this.setSaveDisabled(!ok);
  }

  private _esc(s: string): string {
    return (s ?? "").replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;");
  }
}
